import React from 'react'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import "./style.css";
import Timeslot from "./Timeslot";
import moment from 'moment';
import { uuid } from 'uuidv4';

const Timeslots = ({
  clientSideRef,
  expertSideRef
}) => {
  const {
    state
  } = useStore();
  const {
    schedule,
    takenExpertSlots,
    scheduleRequests
  } = state;
  const {
    timeslots
  } = schedule;

  const Slots = () => {
    const slots = [];

    for (let i = 0; i < 24; i++) {
      slots.push( /*#__PURE__*/React.createElement("div", {
        className: "slot hide" // @ts-ignore
        ,
        id: i,
        key: i,
        style: {
          top: `${i * 23 + 42}px`
        }
      }));
    }

    return slots;
  };

  const date = schedule.timeslots.length && new Date(schedule.timeslots[0].time.start).setHours(0, 0, 0, 0);
  const time = clientSideRef.current && new Date(clientSideRef.current.calendarInst._renderDate).getTime();
  const expertDate = takenExpertSlots.length > 0 && new Date(takenExpertSlots[0].startTime).setHours(0, 0, 0, 0);
  const requestedByClientDate = scheduleRequests.length > 0 && scheduleRequests.map(req => new Date(req.startTime).setHours(0, 0, 0, 0)); // Review: not sure why 5.57 or 5.75 are used, just using these numbers from the old code

  const minuteMap = {
    15: 5.57,
    30: 5.75 * 2,
    45: 5.75 * 3
  };

  const RenderSlot = () => {
    const height = `${11.5 * (schedule.timeslots[0].duration / 30)}px`;
    const hour = new Date(timeslots[0].time.start).getHours() * 23;
    const minutes = new Date(timeslots[0].time.start).getMinutes(); // Default to zero

    const minutesMapped = minuteMap[minutes] || 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "scheduledSlotContainer",
      style: {
        top: hour + minutesMapped,
        height: height
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "scheduledSlotContainer_inner",
      style: {
        height: height
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "m0"
    }, "SCHEDULED")));
  };

  const RenderExpertSlot = () => {
    const {
      startTime,
      endTime
    } = takenExpertSlots[0];
    const expertStart = Number(moment(startTime).format('x'));
    const expertend = Number(moment(endTime).format('x'));
    const otherSlotDuration = (expertend - expertStart) / 1000 / 60;
    const height = `${11.5 * (otherSlotDuration / 30)}px`;
    const hour = new Date(startTime).getHours() * 23;
    const minutes = new Date(startTime).getMinutes(); // Default to zero

    const minutesMapped = minuteMap[minutes] || 0;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%',
        top: hour + minutesMapped,
        position: 'absolute',
        color: 'white',
        height: height,
        fontSize: '14px',
        backgroundColor: '#aaa',
        zIndex: 1
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0 10px',
        height: height,
        alignItems: 'center',
        fontFamily: 'Roboto',
        fontWeight: '600'
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0
      }
    }, "EXPERT ALREADY SCHEDULED")));
  };

  const RenderRequestedSlot = () => {
    const todayRequest = scheduleRequests.filter(req => new Date(req.startTime).setHours(0, 0, 0, 0) === time);
    const Slots = todayRequest.map(req => {
      const minutes = new Date(req.startTime).getMinutes(); // Default to zero

      const minutesMapped = minuteMap[minutes] || 0;
      return /*#__PURE__*/React.createElement("div", {
        key: uuid(),
        style: {
          width: '100%',
          top: new Date(req.startTime).getHours() * 23 + minutesMapped,
          position: 'absolute',
          color: 'white',
          height: `${11.5 * (new Date(req.endTime).getTime() - new Date(req.startTime).getTime()) / 1000 / 60 / 30}px`,
          fontSize: '14px',
          backgroundColor: '#ff6d2a',
          zIndex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          padding: '0 10px',
          height: `${11.5 * (new Date(req.endTime).getTime() - new Date(req.startTime).getTime()) / 1000 / 60 / 30}px`,
          alignItems: 'center',
          fontFamily: 'Roboto',
          fontWeight: '600'
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, "Client requested slot")));
    });
    return Slots;
  };

  return clientSideRef.current && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "slotContainer"
  }, /*#__PURE__*/React.createElement(Timeslot, {
    clientSideRef: clientSideRef,
    expertSideRef: expertSideRef
  }), timeslots.length > 0 && date === time && /*#__PURE__*/React.createElement(RenderSlot, null), takenExpertSlots.length > 0 && expertDate === time && /*#__PURE__*/React.createElement(RenderExpertSlot, null), requestedByClientDate && requestedByClientDate.includes(time) &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(RenderRequestedSlot, null), /*#__PURE__*/React.createElement(Slots, null)));
};

export default Timeslots;